// extracted by mini-css-extract-plugin
export default {"chart":"empty_chart__p-6nc","logo":"empty_logo__zzZ3t"};